import { render, staticRenderFns } from "./ProcessRepairQuickBtns.vue?vue&type=template&id=67de86e5&"
import script from "./ProcessRepairQuickBtns.vue?vue&type=script&lang=js&"
export * from "./ProcessRepairQuickBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports